import { render } from "./Index.vue?vue&type=template&id=27289770&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=27289770&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27289770"],['__file',"resources/js/modules/product-categorization-drag-drop/components/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27289770"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27289770', __exports__)) {
    api.reload('27289770', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=27289770&scoped=true", () => {
    api.rerender('27289770', render)
  })

}


export default __exports__